import { render, staticRenderFns } from "./WatchVideo.vue?vue&type=template&id=296e99e9"
import script from "./WatchVideo.vue?vue&type=script&lang=js"
export * from "./WatchVideo.vue?vue&type=script&lang=js"
import style0 from "./WatchVideo.vue?vue&type=style&index=0&id=296e99e9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports